import { Control } from "../../business-objects/control/control.model";
import { CheckBoxListControlConfig } from "./check-box-list-control-config.model";

export class CheckBoxListControl extends Control {
    config: CheckBoxListControlConfig;
}





// WEBPACK FOOTER //
// ./src/vas/controls/check-box-list/check-box-list-control.model.ts